import { render, staticRenderFns } from "./NewWidget.vue?vue&type=template&id=2650c9d4&scoped=true"
import script from "./NewWidget.vue?vue&type=script&lang=js"
export * from "./NewWidget.vue?vue&type=script&lang=js"
import style0 from "./NewWidget.vue?vue&type=style&index=0&id=2650c9d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.33_css-loader@6.11.0_webpack@5.106.2__lodash@4_f4dcab5a642c45ba976dfd98f0465f82/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2650c9d4",
  null
  
)

export default component.exports